<div class="ai-thread" #scroller>
  <div
    *ngFor="let message of messages; trackBy: trackById"
    class="ai-msg"
    [class.ai-msg--user]="message.role === 'user'"
    [class.ai-msg--assistant]="message.role === 'assistant'"
    [class.ai-msg--rich]="message.views?.length || message.leads?.length">
    <!-- Assistant avatar -->
    <span class="ai-msg__avatar" *ngIf="message.role === 'assistant'"><i class="pi pi-sparkles"></i></span>

    <div class="ai-msg__content">
      <!-- Typing indicator -->
      <div class="ai-typing" *ngIf="message.pending"><span></span><span></span><span></span></div>

      <!-- Attached images on a user turn (sent for the assistant to read) -->
      <div class="ai-msg__images" *ngIf="message.images?.length">
        <img class="ai-msg__image" *ngFor="let img of message.images" [src]="img" alt="Attached image" />
      </div>

      <!-- Message text (user → gray bubble, assistant → plain text) -->
      <div class="ai-msg__bubble" *ngIf="!message.pending && message.content" [class.ai-msg__bubble--error]="message.errored">
        <p class="ai-msg__text">{{ displayText(message) }}</p>
      </div>

      <!-- Choice question asked in prose ("…options are: A, B, …") → pick from a dropdown -->
      <div class="ai-msg__options" *ngIf="isLastMessage(message) && inlineOptions(message) as options">
        <ng-select
          class="ai-msg__options-select"
          [items]="options"
          [searchable]="true"
          [clearable]="false"
          placeholder="Select an option…"
          [disabled]="optionSent(message)"
          [(ngModel)]="optionPicks[message.id]"></ng-select>
        <button
          type="button"
          class="ai-msg__options-send"
          [disabled]="!optionPicks[message.id] || optionSent(message)"
          (click)="sendOption(message)"
          aria-label="Send selection">
          <i class="pi pi-send"></i>
        </button>
      </div>

      <!-- Structured views channel (FRONTEND_HANDOFF §0) — the primary result renderer -->
      <app-ai-assistant-views
        *ngIf="message.views?.length"
        [views]="message.views"
        (openLead)="viewLead.emit($event)"
        (openLeadOnAppointments)="viewLeadAppointments.emit($event)"
        (pickPrompt)="pickPrompt.emit($event)"></app-ai-assistant-views>

      <!-- Legacy fallback: lead detail card(s) parsed from the old `leads[]`/text channel -->
      <div class="ai-lead-cards" *ngIf="!message.views?.length && message.leads?.length">
        <div class="ai-lead-card" *ngFor="let lead of message.leads; trackBy: trackByLeadId">
          <div class="ai-lead-card__head">
            <span class="ai-lead-card__avatar">{{ initials(lead) }}</span>
            <div class="ai-lead-card__heading">
              <strong>{{ lead.name || 'Lead' }}</strong>
              <span class="ai-lead-card__sub" *ngIf="leadSubtitle(lead)">{{ leadSubtitle(lead) }}</span>
            </div>
            <span class="ai-lead-card__temp" [ngClass]="temperatureClass(lead)" *ngIf="lead.temperature">{{ lead.temperature }}</span>
          </div>

          <div class="ai-lead-card__grid">
            <div class="ai-lead-card__field">
              <label>Email</label>
              <span>{{ lead.email || '—' }}</span>
            </div>
            <div class="ai-lead-card__field">
              <label>Phone</label>
              <span>{{ lead.phone || '—' }}</span>
            </div>
            <div class="ai-lead-card__field">
              <label>Lead Source</label>
              <span>{{ lead.source || '—' }}</span>
            </div>
            <div class="ai-lead-card__field">
              <label>Lead Type</label>
              <span>{{ lead.type || '—' }}</span>
            </div>
            <div class="ai-lead-card__field" *ngIf="lead.agent">
              <label>Assigned Agent</label>
              <span>{{ lead.agent }}</span>
            </div>
          </div>

          <div class="ai-lead-card__status-row">
            <label>Status</label>
            <span class="ai-lead-card__status" *ngIf="lead.status">{{ lead.status }}</span>
            <span *ngIf="!lead.status">—</span>
          </div>

          <div class="ai-lead-card__actions">
            <button type="button" class="ai-lead-card__btn ai-lead-card__btn--primary" (click)="openLead(lead)">Open Lead</button>
            <a class="ai-lead-card__btn ai-lead-card__btn--ghost" *ngIf="lead.phone" [href]="telHref(lead.phone)"><i class="pi pi-phone"></i> Call</a>
            <a class="ai-lead-card__btn ai-lead-card__btn--ghost" *ngIf="lead.email" [href]="mailtoHref(lead.email)">
              <i class="pi pi-envelope"></i> Email
            </a>
          </div>
        </div>
      </div>

      <!-- Pending write: confirm / cancel -->
      <app-ai-assistant-action-card
        *ngIf="message.pendingAction"
        [action]="message.pendingAction"
        [state]="message.actionCardState || 'pending'"
        [queuedRemaining]="message.queuedRemaining || 0"
        (confirm)="confirmAction.emit({ message: message, values: $event })"
        (cancel)="cancelAction.emit(message)"></app-ai-assistant-action-card>

      <!-- Blocked create: inline dropdowns so the user can supply what's still needed -->
      <ng-container *ngIf="requiredFields(message) as fields">
        <app-ai-assistant-required-fields
          *ngIf="fields.length"
          [fields]="fields"
          (provide)="provideFields.emit($event)"></app-ai-assistant-required-fields>
      </ng-container>

      <!-- Post-write affordance: open the created lead -->
      <button type="button" class="ai-msg__view-lead" *ngIf="resultLeadId(message) as leadId" (click)="viewLead.emit({ leadId: leadId })">
        <i class="pi pi-external-link"></i> Open Lead
      </button>

      <!-- Retry a failed (transient) turn -->
      <button type="button" class="ai-msg__retry" *ngIf="message.errored && message.retryText" (click)="retry.emit(message)">
        <i class="pi pi-refresh"></i> Retry
      </button>
    </div>
  </div>
</div>
